





















import { Component, Vue, Prop } from 'vue-property-decorator';
import ResponsiveVideos from "@/components/Blocks/ResponsiveVideos.vue";


@Component ({
    components: {
        ResponsiveVideos
    }
})
export default class YoutubePopup extends Vue {
    @Prop() protected youtubeUrl!: string | null;
    @Prop() protected videoObj!: any | null;

    get computedYoutubeId(): string | null {
        const url = this.youtubeUrl || (this.videoObj ? this.videoObj.video : null);
        if (!url) return null;

        const regExp = /^.*(youtu\.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/;
        const match = url.match(regExp);

        if (match && match[2].length === 11) {
            return match[2];
        }
        
        return null;
    }

    private close() {
        this.$emit('close');
    }
}
